package com.flowyride.data.geocoding.photon

import kotlinx.serialization.Serializable

@Serializable
internal data class PhotonResponse(
    val features: List<PhotonFeature> = emptyList(),
)

@Serializable
internal data class PhotonFeature(
    val geometry: PhotonGeometry,
    val properties: PhotonProperties = PhotonProperties(),
)

/** GeoJSON point: `[longitude, latitude]`. */
@Serializable
internal data class PhotonGeometry(
    val coordinates: List<Double> = emptyList(),
)

@Serializable
internal data class PhotonProperties(
    /** house, street, locality, district, city, county, state, country, other. */
    val type: String? = null,
    val name: String? = null,
    val street: String? = null,
    val housenumber: String? = null,
    val postcode: String? = null,
    val city: String? = null,
    val county: String? = null,
    val state: String? = null,
    val country: String? = null,
)
